/** 
 * HTTP requests to the backend. 
 * @author Adrian Rebmann, Yannik Sprengart
 */

import axios from "axios";
import auth from "./auth";

// Get user messages
var messages = require("./messages.json");

// Get config file name from environment
var environment = process.env.NODE_ENV;
var config = require(`../config/${environment}.json`);

// Emits notifications
var events = require('events');
var eventEmitter = new events.EventEmitter();


const BASE_URL = config.server;

export {
  getEventRecommendationsBasedOnSectorAndLocation,
  getEventRecommendationsBasedOnLocation,
  getNewsletter,
  postFeedback,
  deleteBusinessModel,
  resetPasswordForUser,
  updateBusinessmodel,
  updateBrick,
  getQuestionsForBrick,
  getTechnologies,
  getTechnologyByHash,
  getTechnologyByName,
  getBmas,
  getBmaElements,
  getBmaByHash,
  getBmaByName,
  getTenders,
  getTenderByHash,
  putTender,
  postTendertByHash,
  deleteTenderByHash,
  getEvents,
  getEventByHash,
  getProjects,
  getProjectByHash,
  getProjectBusinessModelByHash,
  getProjectBusinessModelSubgraphByHash,
  putProject,
  postProjectByHash,
  postProjectBusinessModelSubgraphByHash,
  deleteProjectByHash,
  getBusinessModel,
  getBusinessModelByHash,
  getBusinessModelSubgraph,
  postBusinessModelSubgraph,
  getNotifications,
  getNotificationByHash,
  getCompanies,
  getCompanyByHash,
  getCompanyByName,
  getCompanyPartners,
  getCompanyProfile,
  getCompanyProjects,
  isCompanyRequestingTechByHash,
  removeCompanyRequestTechByHash,
  isCompanyOfferingTechByHash,
  addCompanyOfferTechByHash,
  removeCompanyOfferTechByHash,
  addCompanyRequestTechByHash,
  postCompany,
  newBusinessmodel,
  updateSettingsForUser,
  changePasswordWithHash,
  changePassword,
  activateUser,
  subscribeToNews,
  deleteUser,
  getTechnologiesForBm,
  getTechpartners,
  getTechnologiesForBma,
  getBmasForTechnology,
  getTechnologiesForBmas,
  getProjectsForBmas,
  getEventsWithFilter,
  getEventsWithinRadius,
  getEventRecommendationsBasedOnSector,
  getIndustrySectors,
  getMainEmphases,
  getKITrainer,
  getKITrainerByHash,
  postKIRCResult,
  postKIRCResult2,
  getKIRC,
  getKIRC2,
  getKIRCResult,
  getKIRCResult2,
  getTrainersWithinRadius,
  saveResForUser,
  getTechCategories,
  getDigitalOffers,
  getDigitalOfferByHash,
  eventEmitter //Emits notification to Notification.vue component
};

function getTechCategories() {
  const url = BASE_URL + config.category;
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function getTechnologiesForBmas(hash) {
  const url = BASE_URL + config.bma + "/technology/" + hash;
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function getProjectsForBmas(hash) {
  const url = BASE_URL + config.bma + "/project/" + hash;
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function getBmasForTechnology(hash) {
  const url = BASE_URL + config.technology + "/bma/connections/" + hash;
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });  
}

function getTechnologiesForBma(hash) {
  const url = BASE_URL + config.bma + "/technology/connections/" + hash;
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function deleteUser() {
  const url = BASE_URL + config.user + "/delete";
  
  return axios
    .get(url, { headers: getHeader() })
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.userDeleteSuccess,
        isError: false
      });
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function getTechpartners(hash) {
  const url = BASE_URL + config.company + "/tech/" + hash;
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function postFeedback(feedback) {
  const url = BASE_URL + config.feedback;

  return axios
    .post(url, feedback, { headers: getHeader() })
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.feedbackSuccess,
        isError: false
      });
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function subscribeToNews(b) {
  const url = BASE_URL + config.user + "/newsletter/" + b;

  return axios
    .get(url, { headers: getHeader() })
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.profileUpdateSucess,
        isError: false
      });
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function activateUser(hash) {
  const url = BASE_URL + config.user + "/activate/" + hash;
  return axios
    .get(url)
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function resetPasswordForUser(username) {
  const url = BASE_URL + config.user + "/password/requestreset/" + username;
  return axios
    .get(url)
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.passwordResetSuccess,
        isError: false
      });
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.passwordResetFail,
        isError: true
      });
      throw err;
    });
}

function changePasswordWithHash(hash, password) {
  const url = BASE_URL + config.user + "/password/reset";

  return axios
    .post(url, { resetHash: hash, password: password })
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.passwordChangeSuccess,
        isError: false
      });
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function changePassword(password) {
  const url = BASE_URL + config.user + "/password/change";

  return axios
    .post(
      url,
      { password: password },
      { headers: getHeader() }
    )
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.passwordChangeSuccess,
        isError: false
      });
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

/**
 * The technology API calls
 */


// TODO: Is this method/endpoint used?
function updateSettingsForUser(settings) {
  const url = BASE_URL + config.user + "/settings";
  return axios
    .post(url, settings, { headers: getHeader() })
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.userUpdateSuccess,
        isError: false
      });
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function getNewsletter() {
  const url = BASE_URL + config.user + "/newsletter";
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function getTechnologies() {
  const url = BASE_URL + config.technology;
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function getTechnologyByHash(hash) {
  const url = BASE_URL + config.technology + "/" + hash;
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function getTechnologiesForBm(hash) {
  const url = BASE_URL + config.technology + "/bma/" + hash;
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });  
}

function getTechnologyByName(name) {
  const url = BASE_URL + config.technology + "/" + name;
  return axios
    .get(url)
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });  
}


/**
 * The Digital Offer API Calls
 */


function getDigitalOffers() {
  const url = BASE_URL + config.digitaloffer;
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function getDigitalOfferByHash(hash) {
  const url = BASE_URL + config.digitaloffer + "/" + hash;
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}
/**
 * The BMA API calls
 */

function getBmas() {
  const url = BASE_URL + config.bma;
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });  
}

function getBmaElements(name) {
  const url = BASE_URL + config.bmaelement + "/" + name;
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });  
}

function getBmaByHash(hash) {
  const url = BASE_URL + config.bma + "/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function getBmaByName(name) {
  const url = BASE_URL + config.bma + "/name/" + name;

  return axios
    .get(url)
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

/**
 * The event API calls
 */
//dependent on current user
function getEventRecommendationsBasedOnLocation() {
  const url = BASE_URL + config.recommend + "/location";

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
  
}

function getEventRecommendationsBasedOnSector() {
  const url = BASE_URL + config.recommend + "/sector";

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });

}

/**
 * The event API calls
 */
//dependent on current user
function getEventRecommendationsBasedOnSectorAndLocation() {
  const url = BASE_URL + config.recommend + "/sectorandlocation";

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function getEvents() {
  const url = BASE_URL + config.event + "/all";
  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    }); 
}

function getEventByHash(hash) {
  const url = BASE_URL + config.event + "/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function getEventsWithFilter(filters) {
  //let request = filters;
  const url = BASE_URL + config.event + "/filter";

  return axios
    .post(url, filters, { headers: getHeader() })
    .then(res => res.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

function getEventsWithinRadius(radius, plz) {
  const url = BASE_URL + config.event + "/radius/" + radius + "/" + plz;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

/**
 * The project API calls
 */
//dependent on current user
function getProjects() {
  const url = BASE_URL + config.project;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });  
}

//dependent on current user
function getProjectByHash(hash) {
  const url = BASE_URL + config.project + "/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });  
}

//dependent on current user
function getProjectBusinessModelByHash(hash) {
  const url = BASE_URL + config.project + "/project/" + hash;

  return axios
    .get(url)
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });
}

//dependent on current user
function getProjectBusinessModelSubgraphByHash(hash, name) {
  const url = BASE_URL + config.project + "/project/" + hash + "/" + name;

  return axios
    .get(url)
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
      throw err;
    });  
}

function putProject(project) {
  let request = project;
  const url = BASE_URL + config.project;

  return axios
    .put(url, request)
    .then(response => {
      return response.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

//dependent on current user
function postProjectByHash(hash, project) {
  let request = project;
  const url = BASE_URL + config.project + "/" + hash;

  return axios
    .put(url, request)
    .then(response => {
      return response.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });  
}

//dependent on current user
function postProjectBusinessModelSubgraphByHash(hash, name, graph) {
  const url = BASE_URL + config.project + "/project/" + hash + "/" + name;
  let request = graph;

  return axios
    .put(url, request)
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

//dependent on current user
function deleteProjectByHash(hash) {
  let request = project;
  const url = BASE_URL + config.project + "/" + hash;

  return axios
    .delete(url)
    .then(response => response.data)
    .catch(err => {
      // TODO: Correct error message
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

/**
 * The company API calls
 */

function getCompanies() {
  const url = BASE_URL + config.company;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function getCompanyByHash(hash) {
  const url = BASE_URL + config.company + "/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function getCompanyByName(name) {
  const url = BASE_URL + config.company + "/" + name;

  return axios
    .get(url)
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

//dependent on current user
function getCompanyProfile() {
  const url = BASE_URL + config.company + "/get";

  return axios
    .get(url, {
      headers: getHeader()
    })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });  
}

//dependent on current user
function getCompanyPartners() {
  const url = BASE_URL + config.company + "/partners";

  return axios
    .get(url)
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });  
}

//dependent on current user
function getCompanyProjects() {
  const url = BASE_URL + config.company + "/projects";

  return axios
    .get(url)
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });  
}

//dependent on current user
function postCompany(profile) {
  const url = BASE_URL + config.company + "/update";
  return axios
    .post(url, profile, { headers: getHeader() })
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.companyUpdateSuccess,
        isError: false
      });
      return res.data;
      return res;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function isCompanyOfferingTechByHash(hash) {
  const url = BASE_URL + config.company + "/offers/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function isCompanyRequestingTechByHash(hash) {
  const url = BASE_URL + config.company + "/requests/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function addCompanyOfferTechByHash(hash) {
  const url = BASE_URL + config.company + "/offer/add/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function removeCompanyOfferTechByHash(hash) {
  const url = BASE_URL + config.company + "/offer/remove/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function addCompanyRequestTechByHash(hash) {
  const url = BASE_URL + config.company + "/request/add/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function removeCompanyRequestTechByHash(hash) {
  const url = BASE_URL + config.company + "/request/remove/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

/**
 * The notification API calls
 */

function getNotifications() {
  const url = BASE_URL + config.notification;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function getNotificationByHash(hash) {
  const url = BASE_URL + config.notification + "/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

/**
 * The business model API calls
 */

//dependent on current user
function getBusinessModel() {
  const url = BASE_URL + config.businessmodel;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

//dependent on current user
function getBusinessModelByHash(hash) {
  const url = BASE_URL + config.businessmodel + "/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

//dependent on current user
function getBusinessModelSubgraph(hash, brick) {
  brick = brick.replace("ü", "u").replace("ä", "a");
  const url = BASE_URL + config.businessmodel + "/" + hash + "/" + brick;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

//dependent on current user
function postBusinessModelSubgraph(hash, name, graph) {
  name = name.replace("ü", "u").replace("ä", "a");
  const url = BASE_URL + config.businessmodel + "/" + hash + "/" + name;

  return axios
    .post(url, graph, { headers: getHeader() })
    .then(res => {
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function updateBrick(hash, brick, graph) {
  const url = BASE_URL + config.businessmodel + "/update/" + hash + "/" + brick;
  brick = brick.replace("ü", "u").replace("ä", "a");
  //TODO: check success message
  return axios
    .post(url, graph, { headers: getHeader() })
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.genericSuccess,
        isError: false
      });
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function newBusinessmodel(name) {
  name = name
    .replace("ü", "u")
    .replace("ä", "a")
    .replace("ö", "o");
  const url = BASE_URL + config.businessmodel + "/" + "new" + "/" + name;

  return axios
    .get(url, {
      headers: getHeader()
    })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function getHeader() {
  let headers = {
    Authorization: "Bearer " + auth.getToken()
    // "Access-Control-Allow-Origin": "*",
    // "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
  };
  return headers;
}

function getHeaderNoAuth() {
  let headers = {
    // "Access-Control-Allow-Origin": "*",
    // "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
  };
  return headers;
}

function getQuestionsForBrick(brick) {
  const url = BASE_URL + config.question + "/" + brick;

  return axios
    .get(url)
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
  
}

function updateBusinessmodel(hash, graph) {
  const url = BASE_URL + config.businessmodel + "/update/" + hash;
  // TODO: check  success message
  return axios
    .post(url, graph, { headers: getHeader() })
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.genericSuccess,
        isError: false
      });
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function deleteBusinessModel(hash) {
  const url = BASE_URL + config.businessmodel + "/delete/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.businessModelDeleteSuccess,
        isError: false
      });
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function getKITrainer() {
  const url = BASE_URL + config.kitrainer;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function getKITrainerByHash(hash) {
  const url = BASE_URL + config.kitrainer + "/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function getMainEmphases() {
  const url = BASE_URL + config.mainemphases;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function getIndustrySectors() {
  const url = BASE_URL + config.industrysector;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });  
}

function getTrainersWithinRadius(radius, plz) {
  const url = BASE_URL + config.kitrainer + "/radius/" + radius + "/" + plz;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });  
}

/**
 * KIRC API-Calls
 */
function getKIRC() {
  const url = BASE_URL + config.kirc + "/questions/all";

  return axios
    .get(url, { headers: getHeaderNoAuth() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });  
}

function getKIRC2() {
  const url = BASE_URL + config.kirc + "/questions/all2";

  return axios
    .get(url, { headers: getHeaderNoAuth() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });  
}

function postKIRCResult2(kirc) {
  const url = BASE_URL + config.kirc + "/result/create/async2";
  //console.log(JSON.stringify(kirc));
  //TODO: check success message
  return axios
    .post(url, kirc, { headers: getHeader() })
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.genericSuccess,
        isError: false
      });
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function postKIRCResult(kirc) {
  const url = BASE_URL + config.kirc + "/result/create/async";
  //console.log(JSON.stringify(kirc));
  //TODO: check success message
  return axios
    .post(url, kirc, { headers: getHeader() })
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.genericSuccess,
        isError: false
      });
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function getKIRCResult(hash) {
  const url = BASE_URL + config.kirc + "/result/get/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function getKIRCResult2(hash) {
  const url = BASE_URL + config.kirc + "/result/get2/" + hash;

  return axios
    .get(url, { headers: getHeader() })
    .then(response => response.data)
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function getEventRecommendationsBasedOnTag(tag) {
  const url = BASE_URL + config.event + "/tag";
  // TODO: Check success message
  return axios
    .post(url, tag, { headers: getHeader() })
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.genericSuccess,
        isError: false
      });
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isError: true
      });
    });
}

function saveResForUser(hash) {
  const url = BASE_URL + config.kirc + "/result/add_user/" + hash;
  console.log(hash);
  //  TODO: Check success message
  return axios
    .post(url, {}, { headers: getHeader() })
    .then(res => {
      eventEmitter.emit('Notification', {
        msg: messages.genericSuccess,
        isError: false
      });
      return res.data;
    })
    .catch(err => {
      eventEmitter.emit('Notification', {
        msg: messages.genericFail,
        isErrnor: true
      });
    });
}



// WEBPACK FOOTER //
// ./src/api.js